module.exports = __webpack_public_path__ + "static/media/validacao_data_dark.150ea9b5.svg";